/* eslint-disable no-param-reassign */
import { createAction, createReducer } from '@reduxjs/toolkit'
import { farmsConfig } from '~/config/constants';
import { DaoFarmDataResponse, StatsState } from "./types";

const initialState: StatsState = {
  treasuryBurnLastest7d: undefined,
  daoFarmData: Object.keys(farmsConfig).reduce((accum, key) => {
    accum[key] = farmsConfig[key].map(({ pid }) => {
      return {
        pid,
        allowance: '0',
        tokenBalance: '0',
        stakedBalance: '0',
        earnings: '0',
      }
    })
    return accum
  }, {}),

  /* daoFarmData: farmsConfig.map( farm => {
     return {
      pid: farm.pid,
      allowance: '0',
      tokenBalance: '0',
      stakedBalance: '0',
      earnings: '0',
    }}), */
}

export const updateTreasuryBurnData = createAction<{ treasuryBurnLastest7d: number }>('stats/updateTreasuryBurnData') 

export const updateDaoFarmData = createAction<{ daoFarmDataResponse: DaoFarmDataResponse[]; chainId: number }>('stats/updateDaoFarmData')



export default createReducer(initialState, (builder) => {
  builder.addCase( updateTreasuryBurnData, (state, { payload: { treasuryBurnLastest7d } }) => {
    state.treasuryBurnLastest7d = treasuryBurnLastest7d
  })
  builder.addCase( updateDaoFarmData, (state, { payload }) => {
    state.daoFarmData[payload.chainId] = state.daoFarmData[payload.chainId].map( (current) => {
      const liveData = payload.daoFarmDataResponse.find( (liveDaoFarmData) => liveDaoFarmData.pid === current.pid)
      return { ...current, ...liveData}
    })
  })
  
})

